import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Heart } from "lucide-react";

const RoastFirmowy = () => (
  <SeoPageLayout title="Roast" titleAccent="firmowy">
    <SeoSection title="Czym jest roast firmowy?">
      <p>Roast firmowy to format komediowy, w którym komik żartobliwie komentuje firmę, jej pracowników, szefów i codzienne sytuacje biurowe. To ciepła, przyjazna forma humoru, która przełamuje hierarchie, buduje bliskość i pokazuje, że w firmie można się śmiać razem - a nie z siebie nawzajem.</p>
    </SeoSection>

    <SeoSection title="Jak przebiega roast firmowy?">
      <p>Komik wcześniej zbiera informacje o firmie, zabawnych sytuacjach i charakterystycznych osobach. Na scenie żartobliwie komentuje zebrany materiał - nawiązuje do firmowych legend, rytuałów i codziennych absurdów. Wszystko w duchu życzliwości i dobrego smaku. Efekt? Sala pęka ze śmiechu, a roastowani czują się docenieni.</p>
    </SeoSection>

    <SeoSection title="Kiedy roast firmowy sprawdza się najlepiej?">
      <SeoStyledList items={[
        "Wigilia firmowa - podsumowanie roku z humorem",
        "Pożegnanie odchodzącego pracownika lub managera",
        "Jubileusz firmy - roast historii i tradycji",
        "Integracja nowego zespołu po fuzji",
        "Impreza po zamknięciu udanego projektu"
      ]} />
    </SeoSection>

    <SeoSection title="Granice dobrego smaku">
      <p>Roast firmowy to nie roast telewizyjny. Nasi komicy doskonale wiedzą, gdzie przebiega granica. Humor jest zawsze życzliwy, inkluzywny i profesjonalny. Nie żartujemy z wyglądu, orientacji czy prywatnych spraw. Skupiamy się na zabawnych sytuacjach zawodowych, firmowych tradycjach i uniwersalnych absurdach pracy biurowej.</p>
      <SeoHighlightBox icon={Heart}>
        Każdy roast jest poprzedzony konsultacją z organizatorem - wspólnie ustalamy granice, tematy i osoby, które mogą być żartobliwie komentowane.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Przygotowanie roastu">
      <SeoNumberedSteps steps={[
        { title: "Zbieranie materiału", description: "Ankiety (anonimowe lub jawne), rozmowy z organizatorem i research firmy." },
        { title: "Tworzenie materiału", description: "Im więcej informacji otrzymamy, tym celniejszy i zabawniejszy będzie roast." },
        { title: "Efekt zaskoczenia", description: "Cały proces jest dyskretny - roastowani nie wiedzą, co ich czeka, co potęguje efekt zaskoczenia i radości." },
      ]} />
    </SeoSection>
  </SeoPageLayout>
);

export default RoastFirmowy;
